module.exports = __webpack_public_path__ + "static/media/马房.a586ac18.svg";